import { render, staticRenderFns } from "./VNavbar.vue?vue&type=template&id=6b1eb3d1&scoped=true&"
import script from "./VNavbar.vue?vue&type=script&lang=js&"
export * from "./VNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1eb3d1",
  null
  
)

export default component.exports